import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import style from './Lobby.module.css';
import { Loader } from '../../ui-kit/components/Loader/Loader';

interface Configurator {
  folder: string;
  title: string;
  description: string;
}

interface IConfig {
  configurators: Configurator[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface IProps {}

interface IState {
  configurators: Configurator[];
  loaded: boolean;
}

export class Lobby extends Component<IProps, IState> {
  state: IState = {
    configurators: [],
    loaded: false,
  };

  async componentDidMount() {
    const response = await fetch('./lobby.json');
    const json: IConfig = await response.json();

    this.setState({
      configurators: json.configurators,
      loaded: true,
    });
  }

  render() {
    const { loaded, configurators } = this.state;
    return (
      <div className={style.root}>
        <header className={style.lobbyHeader}>
          <h2 className={style.lobbyTitle}>CanvasLogic Platform Lobby</h2>
          <p className={style.lobbyDescription}>Examples of Basic Configurators</p>
        </header>
        <div className={style.gallery}>
          {loaded ? (
            configurators.length === 0 ? (
              <p>No configurators available</p>
            ) : (
              configurators.map((cfg) => (
                <Card key={cfg.folder} folder={cfg.folder} title={cfg.title} description={cfg.description} />
              ))
            )
          ) : (
            <div className={style.loaderWrapper}>
              <Loader size={200} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

function Card({ title, description, folder }: Configurator) {
  return (
    <div className={style.card}>
      <h3 className={style.cardTitle}>{title}</h3>
      <p className={style.cardDescription}>{description}</p>
      <Link to={`/configurator/${folder}`} className={style.cardOpenLink}>
        Open
      </Link>
    </div>
  );
}
